/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

import { useIconIdPrefix } from '~/components/Icons/utils/useIconIdPrefix';

const WifiSecurityPlus = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix('WifiSecurityPlus');

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--wifiSecurityPlus"
      {...props}
    >
      <g clipPath={`url(#${prefix}-clip0_8751_4072)`}>
        <path
          d="M8.93359 1.30014C10.0669 1.9668 11.3338 2.26648 12.6338 2.13315L14 2.00034V7.56674C14 8.06672 13.934 8.56689 13.834 9.03354C14.7338 9.70023 15.334 10.8005 15.334 12.0003C15.3338 14.0335 13.7002 15.6664 11.667 15.6664C10.567 15.6664 9.56706 15.1664 8.90039 14.3997L7.33398 15.3333L3.90039 13.2669C1.90041 12.0669 0.667015 9.90005 0.666992 7.56674V2.00034L2 2.13315C3.29994 2.26648 4.60023 1.96674 5.7002 1.30014L7.33398 0.333344L8.93359 1.30014ZM11 11.3333H9V12.6664H11V14.6664H12.334V12.6664H14.334V11.3333H12.334V9.33334H11V11.3333ZM6.40039 2.46713C5.06709 3.26707 3.53327 3.60033 2 3.50034V7.59995C2 9.46661 2.96725 11.1997 4.60059 12.1664L7.33398 13.8001L8.2334 13.2669C8.06677 12.867 8.00003 12.4336 8 12.0003C8 11.9091 8.00428 11.8184 8.01074 11.7289C7.78037 11.9183 7.48675 12.0335 7.16699 12.0335C6.43366 12.0335 5.83398 11.4329 5.83398 10.6996C5.83423 9.96642 6.43381 9.36655 7.16699 9.36655C7.75098 9.36655 8.24951 9.74747 8.42871 10.2728C9.04374 9.11637 10.2593 8.33334 11.667 8.33334C12.0003 8.33334 12.3006 8.36713 12.6006 8.46713C12.6339 8.16715 12.667 7.86672 12.667 7.56674V3.46713C11.1337 3.60046 9.59992 3.23295 8.2666 2.43295L7.33398 1.89975L6.40039 2.46713ZM7.5332 6.69955C8.39987 6.69955 9.20052 7.00047 9.86719 7.46713L9.10059 8.53354C8.66736 8.20028 8.1339 8.03362 7.56738 8.03354H6.90039C6.33372 8.03354 5.80052 8.20034 5.36719 8.50034L4.56738 7.43295C5.20065 6.96649 6.00072 6.69955 6.86719 6.69955H7.5332ZM7.5 4.03354C8.96665 4.03354 10.3336 4.50003 11.4336 5.33334L10.6338 6.39975C9.76713 5.76644 8.66665 5.36655 7.5 5.36655H6.83398C5.66732 5.36655 4.60006 5.73321 3.7334 6.36655L2.93359 5.30014C4.03359 4.50014 5.36732 4.03354 6.83398 4.03354H7.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id={`${prefix}-clip0_8751_4072`}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

WifiSecurityPlus.displayName = 'wifiSecurityPlus';

export default WifiSecurityPlus;
